


















import Vue from 'vue'
import Restaurants, { RestaurantPublic } from '@/services/Restaurants'

export default Vue.extend({
  name: 'Home',
  data() {
    return {
      restaurantsToShow: ['three', 'q42', 'lindelaan'],
      restaurantList: {} as RestaurantPublic[],
    }
  },
  async created() {
    this.restaurantsToShow = Object.keys(await Restaurants.getAllPublicRestaurants()).sort()
    this.restaurantList = await Promise.all(
      this.restaurantsToShow.map(async key => {
        const obj = await Restaurants.getPublicRestaurant(key)
        // @ts-ignore
        obj.id = key
        return obj
      })
    )
  },
})
